export enum JOB_ACTION_TYPES {
  CREATE_JOB = 'Create job',
  EDIT_JOB = 'Edit job',
  CLONE_JOB = 'Clone job'
}
